import { render, staticRenderFns } from "./mortgage-copy-sent-loan-officer.vue?vue&type=template&id=7ca6fc84"
import script from "./mortgage-copy-sent-loan-officer.vue?vue&type=script&lang=js"
export * from "./mortgage-copy-sent-loan-officer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports